import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'reaouter';
import { HeadGear } from './'

const IntroductoryProps = {
	title: PropTypes.string.isRequired,
	descriptions: PropTypes.arrayOf(PropTypes.string),
	link: PropTypes.string,
	requirement: PropTypes.string,
	columns: PropTypes.arrayOf(
		PropTypes.shape({ title: PropTypes.string, descriptions: PropTypes.string })
	),
};

const Introductory = ({
	title,
	descriptions,
	link,
	requirement,
    columns,
    brandImage,
}) => {
	return (
		<div className='container'>
			 <HeadGear>
				<HeadGear.Meta 
					title={`Mytabworks | ${title}`}
					description={descriptions.join(', ').replace(/\.|\n/g, '')}
					image='/images/icons/icon-512x512.png'
				/>
            </HeadGear>
			<div className='hero'>
				<div className='row flex-dir-reverse-row'>
					<div className='column-sm-6'>
						{brandImage}
					</div>
					<div className='column-sm-6'>
						<h1 className='title'>{title}</h1>
						{descriptions.map((description) => (
							<h4 key={description} className='description n-text-dim-color'>{description}</h4>
						))}
						<Link
							className='g-started n-btn n-btn-lg'
							to={link}
							label='Getting Started'
						/>
						{requirement && (
							<h6 className='requirement n-text-dim-color'>Requirement: {requirement}</h6>
						)}
					</div>
				</div>
			</div>
			<div className='row'>
				{columns.map((column) => (
					<div key={column.title} className={`column-sm-${12 / columns.length}`}>
						<div className="stunning-card n-flat">
							{column.icon && (
								<div className="stunning-card-img">
									<i className={`mytabworks ${column.icon}`} />
								</div>
							)}
							<h5 className="stunning-card-title">{column.title}</h5>
							<p className="stunning-card-description n-text-dim-color">{column.description}</p>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

Introductory.propTypes = IntroductoryProps;

export default Introductory;
